function index(el) {
    var children = el.parentNode.childNodes,
        i = 0;
    for (; i < children.length; i++) {
        if (children[i] == el) {
            return i;
        }
    }
    return -1;
}

module.exports = function store(state, emitter) {

  state.dragging = null
  state.sampleBoard = [
    null, null, null,
    null, null, null,
    null, null, null
  ]
  state.customSamplePack = false
  state.selectedSample = null

  // Drag: https://developer.mozilla.org/en-US/docs/Web/API/Document/drag_event
  emitter.on('dragstart', (event) => {
    state.dragging = event.target.attributes['data-file'].value
    emitter.emit('render')
  })
  emitter.on('dragend', (event) => {
    state.dragging = null
    emitter.emit('render')
  })
  emitter.on('dragover', (event) => {
    // prevent default to allow drop
    event.preventDefault()
  })
  emitter.on('dragenter', (event) => {
    if (event.target && event.target.closest) {
      let parent = event.target.closest('li')
      if (parent && parent.classList && parent.classList.contains('grid-button')) {
        parent.style.opacity = 0.5
      }
    }
  })
  emitter.on('dragleave', (event) => {
    if (event.target && event.target.closest) {
      let parent = event.target.closest('li')
      // reset background of potential drop target when the draggable element leaves it
      if (parent && parent.classList && parent.classList.contains('grid-button')) {
        parent.style.opacity = ''
      }
    }
  })
  emitter.on('drop', (event) => {
    console.log('drop')
    // prevent default action (open as link for some elements)
    event.preventDefault()
    emitter.emit('deselectsample')
    if (event.target && event.target.closest) {
      console.log('drop', event.target)
      //check if the event target is fired on the sampler grid or any of its children
      let onSamplerGrid = event.target.closest('#sampler-board')
      if (onSamplerGrid) {
        state.sampleBoard.push(state.dragging)
        state.customSamplePack = true
      }
      else {
        return
      }

      state.dragging = null
      state.customSamplePack = true
    }
    emitter.emit('unfocus')
    emitter.emit('render')
  })

  emitter.on('selectsample', (item) => {
    state.selectedSample = item
    emitter.emit('render')
  })
  emitter.on('deselectsample', () => {
    state.selectedSample = null
    emitter.emit('render')
  })

  emitter.on('placesample', (i) => {
    console.log('placesample', i)
    state.sampleBoard[i] = state.selectedSample
    state.customSamplePack = true
    state.selectedSample = null
    emitter.emit('unfocus')
    emitter.emit('flashbutton', i)
    emitter.emit('render')
  })
}
